var _excluded = ["leftIcon", "isSelected", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { MenuItem, MenuIcon, useMenuItem, forwardRef } from '@chakra-ui/react';
import { CheckIcon } from "../Icons/General/CheckIcon";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DropdownItem = forwardRef((props, ref) => {
  var {
    leftIcon,
    isSelected,
    children
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var menuitemProps = useMenuItem(rest, ref);
  var shouldWrap = leftIcon;

  var _children = shouldWrap ? /*#__PURE__*/_jsx("span", {
    style: {
      pointerEvents: 'none',
      flex: 1
    },
    children: children
  }) : children;

  var leftIconSpacing = '0.75rem';
  var checkIconSpacing = '0.75rem';
  return /*#__PURE__*/_jsxs(MenuItem, _extends({
    textStyle: "body-normal-medium",
    justifyContent: "space-between"
  }, menuitemProps, {
    textColor: props.isSelected ? 'primary.400' : 'neutral.500',
    _focus: {
      bg: 'primary.100'
    },
    _active: {
      bg: 'primary.200'
    },
    children: [leftIcon && /*#__PURE__*/_jsx(MenuIcon, {
      marginEnd: leftIconSpacing,
      children: leftIcon
    }), _children, isSelected && /*#__PURE__*/_jsx(MenuIcon, {
      marginStart: checkIconSpacing,
      marginEnd: checkIconSpacing,
      children: /*#__PURE__*/_jsx(CheckIcon, {})
    })]
  }));
});
//# sourceMappingURL=DropdownItem.js.map